import React, { useEffect, useState } from 'react';
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10, TablesWidget5 } from "../../../smallnation/partials/widgets"

import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";

import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import { useNavigate, useHistory, useLocation } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UsNumberValidate from "../../modules/utility/usNumberValidate"
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';

const EditJobseeker: FC = () => {
  const intl = useIntl();
  let history = useHistory();
  const [categories, setCategory] = useState([]);
  const [jobTypes, setJobType] = useState([]);
  const [educations, setEducation] = useState([]);
  const red = "red";
  const [itemName, setFieldName] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [fileBase64, setFileBase64] = useState('');
  const [personalProfiles, setPersonalProfile] = useState('');
  const [educationInformation, setEducationInfo] = useState('');
  const [trainingInformation, setTrainingInfo] = useState('');
  const [seekingPositionfor, setSeekingPosition] = useState('');
  const [profileInfo, setProfileInfo] = useState([]);
  const [schoolList, setSchoolList] = useState([]);
  const [collegeInfo, setCollegeInfo] = useState([]);
  const [jobSeekerResumePath, setJobSeekerPath] = useState('');

  const location99 = useLocation();
  const queryParams99 = new URLSearchParams(location99.search);
  const profileId = queryParams99.get('profileId');

  var onload_profstat = '';

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function validateCheck() {

  }

  function handleChangePersonalProfileDesc(content) {
    setPersonalProfile(content);
  }

  function handleChangeTrainingInfoDesc(content) {
    setTrainingInfo(content);
  }

  function handleChangeSeekingPositionDesc(content) {
    setSeekingPosition(content);
  }

  //function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
  function handleImageUploadBefore(files, info, uploadHandler) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }

  function getImage() {
    var files = document.getElementById('resume').files;
    console.log(files);
    if (files.length > 0) {

      var fname = files[0].name;
      // var fextn = fname.substr(0, fname.lastIndexOf('.'));
      var fextn = fname.split(".").pop();
      // alert(fextn);
      var fileActName = fname.split(".")[0];
      // alert(fileActName);
      setFileName(fileActName);
      setFileExtension(fextn);
      getBase64(files[0]);

      if (fextn != "doc" && fextn != "docx" && fextn != "pdf") {

        $("#fileError").show();
        return false;
      } else {
        $("#fileError").hide();
      }

    }
  }
  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // console.log(reader.result);
      var base64result = reader.result.split(',')[1];
      setFileBase64(base64result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  const submitValue = () => {

    var catofExpertiseArray = [];
    $.each($("input[name='categoryid']:checked"), function () {
      catofExpertiseArray.push($(this).val());
    });
    console.log('********');
    console.log('onload_profstat :  ' + onload_profstat);
    var stat_forredirect = $('#onloadprofstat').val();
    console.log('onload_profstat :  ' + stat_forredirect);
    /* var isCheck=true;
     if(catofExpertiseArray.length == 0){
       isCheck=false;
       $("#categoryError").show();
      // alert("test");
      }else{
       // alert(checkedValues);
        isCheck=true;
       $("#categoryError").hide();
      } */

    var validateEditorTxt = 1;
    if ($('#approval_status').val() == '') {
      $("#statusValidMsg").show();
      $(window).scrollTop($('#statusValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#statusValidMsg").hide();
    }

    if ($('#first_name').val() == '') {
      $("#firstNameValidMsg").show();
      $(window).scrollTop($('#firstNameValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#firstNameValidMsg").hide();
    }

    if ($('#last_name').val() == '') {
      $("#lastNameValidMsg").show();
      $(window).scrollTop($('#lastNameValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#lastNameValidMsg").hide();
    }

    if ($('#phone_number').val() == '') {
      $("#phoneValidMsg").show();
      $(window).scrollTop($('#phoneValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#phoneValidMsg").hide();
    }

    if ($('#educationId').val() == '') {
      $("#educationValidMsg").show();
      $(window).scrollTop($('#educationValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#educationValidMsg").hide();
      if ($('#educationId').val() == 3) {
        if ($('#schoolId').val() == '') {
          $("#schoolValidMsg").show();
          $(window).scrollTop($('#schoolValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#schoolValidMsg").hide();
        }

        if ($('#schoolId').val() == 0 && $('#schoolIdOther').val() == '') {
          $("#schoolIdOtherValidMsg").show();
          $(window).scrollTop($('#schoolIdOtherValidMsg').position().top);
          validateEditorTxt = 0;
        } else {
          $("#schoolIdOtherValidMsg").hide();
        }

      }
      else {
        console.log('here');
        if ($('#university_name').val() == '') {
          $("#university_nameValidMsg").show();
          $(window).scrollTop($('#university_nameValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#university_nameValidMsg").hide();
        }

        if ($('#university_name').val() == 22 && $('#collegeIdOther').val() == '') {
          $("#collegeIdOtherValidMsg").show();
          $(window).scrollTop($('#collegeIdOtherValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#collegeIdOtherValidMsg").hide();
        }
      }
    }

    if ($('#schoolId').val() == '' && $('#educationId').val() == '3') {
      $("#schoolValidMsg").show();
      $(window).scrollTop($('#schoolValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#schoolValidMsg").hide();
    }

    var selectedEduction = $("#continueEducationSelect").val();
    if(selectedEduction == '' || selectedEduction == null){
      $("#continuingEducationValidMsg").show();
      $(window).scrollTop($('#continuingEducationValidMsg').position().top);
      validateEditorTxt = 0;
    } else{
      if ($('#continueEducationSelect').val() == 'Y') {
        if ($('#collegeId').val() == '') {
          $("#collegeValidMsg").show();
          $(window).scrollTop($('#collegeValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#collegeValidMsg").hide();
        }

        if ($('#pursuingProgram').val() == '') {
          $("#pursuingProgramValidMsg").show();
          $(window).scrollTop($('#pursuingProgramValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#pursuingProgramValidMsg").hide();
        }
      }
    }


    if ($('#jobType').val() == '') {
      $("#jobtypeValidMsg").show();
      $(window).scrollTop($('#jobtypeValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#jobtypeValidMsg").hide();
    }

    if (catofExpertiseArray.length == 0) {
      $("#categoryValidMsg").show();
      $(window).scrollTop($('#categoryValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#categoryValidMsg").hide();
    }

    if (personalProfiles == "") {
      $("#personalProfileValidMsg").show();
      $(window).scrollTop($('#personalProfileValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#personalProfileValidMsg").hide();
    }

    /*
    if(educationInformation == ""){
      $("#educationInfoValidMsg").show();  
     $(window).scrollTop($('#educationInfoValidMsg').position().top);
      validateEditorTxt = 0;     
    }else{
      $("#educationInfoValidMsg").hide();  
    } */

    if (trainingInformation == "") {
      $("#trainingInfoValidMsg").show();
      $(window).scrollTop($('#trainingInfoValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#trainingInfoValidMsg").hide();
    }


    if (seekingPositionfor == "") {
      $("#seekingPositionValidMsg").show();
      $(window).scrollTop($('#seekingPositionValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#seekingPositionValidMsg").hide();
    }

    if (validateEditorTxt == 0) {
      return false;
    }
    /*
        if( (fileExtension != "doc" && fileExtension != "docx" && fileExtension != "pdf" ) || (fileExtension == "")  ){
          //document.getElementById('logo').reset();
          $("#fileError").show();
          return false;
       }else{
          $("#fileError").hide();
       }
    */

       if($('#deactivate_profile').is(":checked")){
        var deactive_stat = 'Y';
    }
    else{
      var deactive_stat = 'N';
    }

    var selectedEduction = $('#continueEducationSelect').val();
    const requestObject = {
      "profileId": profileId,
      "firstName": $('#first_name').val(),
      "lastName": $('#last_name').val(),
      "email": $('#email_id').val(),
      "phone": $('#phone_number').val(),
      //"password":profileInfo.password,
      "educationExperiance": "NA",
      "personalProfile": personalProfiles,
      //"educationExperiance":educationInformation,
      "certificationTraining": trainingInformation,
      "jobType": $('#jobType').val(),
      "enrolledCollege": $('#collegeId').val(),
      "pursuingProgram": $("#pursuingProgram").val(),
      "levelEducation": $("#educationId").val(),
      "listSchool": $("#schoolId").val(),
      "continueEducation": selectedEduction,
      "listSchoolOther": $('#schoolIdOther').val(),
      "listCollegeId": $('#university_name').val(),
      "listCollegeOther": $('#collegeIdOther').val(),
      "schoolIdOther": $("#schoolIdOther").val(),
      "lookingFor": seekingPositionfor,
      // "resumePath": $("#resume").val(),

      "siteId": 2,
      "status": $('#approval_status').val(),
      "categoriesOfExpertise": catofExpertiseArray,
      "profileDisableStatus" : deactive_stat
    }

    var files = document.getElementById('resume').files;
    console.log(files);
    if (files.length > 0) {
      requestObject.fileName = fileName;
      requestObject.fileExtension = fileExtension;
      requestObject.pdfByString = fileBase64;
    }
    
    //"pdfByString":fileBase64,
    //"fileName":fileName,
    //"fileExtension":fileExtension,
    /*
        if(fileExtension != ""){
          //
          if(fileExtension != "doc" && fileExtension != "docx" && fileExtension != "pdf" && fileExtension != "txt"  ){
            //document.getElementById('logo').reset();
            $("#fileError").show();
            return false;
         }else{
            $("#fileError").hide();
            requestObject.fileName = fileName;
            requestObject.fileExtension = fileExtension;
            requestObject.pdfByString = fileBase64;
         }
          //
        }
    */

    console.log(requestObject);
    //return false;
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };
    services.adminEditProfile(requestOptions).then((res) => {
      console.log(res);
      if (res.code == '200') {
        $("#editjobseekersuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#editjobseekersuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          if (stat_forredirect == 'Published' || stat_forredirect == 'published') {
            history.push('/profiledirectory');
          }
          else if (stat_forredirect == 'pending' || stat_forredirect == 'Pending') {
            history.push('/pendingprofile');
          }
          else {
            history.push('/expiredprofile');
          }
        }, 1000);



      }
      else {
        $("#editjobseekerfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#editjobseekerfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);

      }
    });
  }

  const getEducation = () => {
    services.getEducation().then((res) => {
      console.log("getEducation data=" + JSON.stringify(res.data));
      setEducation(res.data.content);
    });
  }

  function getProfileData(profileId) {
    services.adminGetProfile(profileId).then((res) => {
      console.log("######################397");
      console.log(JSON.stringify(res));
      if (res.data) {
        try {
          if (res.data.personalProfile == null) {
            res.data.personalProfile = "";
          }
          if (res.data.educationExperiance == null) {
            res.data.educationExperiance = "";
          }

          if (res.data.certificationTraining == null) {
            res.data.certificationTraining = "";
          }

          if (res.data.lookingFor == null) {
            res.data.lookingFor = "";
          }

          setProfileInfo(res.data);
        } catch (ex) {
          console.log("---------->" + ex);
        }

        var profinfo = res.data;
        $("#first_name").val(profinfo.firstName);
        $("#last_name").val(profinfo.lastName);
        $("#email_id").val(profinfo.email);
        $("#phone_number").val(profinfo.phone);
        $("#password").val(profinfo.password);
        $("#conf_password").val(profinfo.password);
        $('#approval_status').val(profinfo.status);
        var jstatus = profinfo.status;
        onload_profstat = profinfo.status;
        $('#onloadprofstat').val(profinfo.status);
        //alert(onload_profstat);
        if (jstatus == "Expired" || jstatus == "expired") {
          $('#approval_status').val('expired');
        }
        $("#enrolledCollege").val(profinfo.enrolledCollege);
        $("#educationId").val(profinfo.levelEducation);

        $("#jobType").val(res.data.jobType);
        $('#schoolId').val(profinfo.listSchool);
        if (profinfo.continueEducation == 'Y') {
          $("#continueEduDiv").show();
        }
        else {
          $("#continueEduDiv").hide();
        }
        $('#pursuingProgram').val(profinfo.pursuingProgram);

        var companyCatIn = res.data.categoriesOfExpertise;

        if(res.data.profileDisableStatus == 'Y'){
          $('input[name="deactivate_profile"]').prop("checked", true);
        }


        /*    var catarray = res.data.categoriesOfExpertise;
            for(var i=0; i<catarray.length; i++){
              console.log(catarray[i]);
                  $('#'+catarray[i]).prop('checked', true);
           } 
   */
        setTimeout(() => {
          for (var i = 0; i < companyCatIn.length; i++) {
            //$("input[value='" + val + "']").prop('checked', true);
            console.log("###" + companyCatIn[i]);
            //$('input[name="categoryid"][value="' + companyCatIn[i] + '"]').prop("checked", true);
            $('input[name="categoryid"][value="' + companyCatIn[i] + '"]').trigger("click");
          }
          validateCheck();
          $("#schoolId").val(res.data.listSchool);

          $('#educationId').val(res.data.levelEducation);
          $('#collegeIdOther').val(res.data.listCollegeOther);
          $('#schoolIdOther').val(res.data.listSchoolOther);
          console.log(res.data.educationId);
          if (res.data.levelEducation == 3) {
            $('#school_div').show();
            $('#college_div').hide();

            $("#schoolId").val(res.data.listSchool);
            if (res.data.listSchool == '33') {
              $('#schoolIdOtherDiv').show();
            }
            $('#university_name').val();
          }
          else {
            $('#school_div').hide();
            $('#college_div').show();

            $("#schoolId").val();
            $('#university_name').val(res.data.listCollegeId);
            if (res.data.listCollegeId == '22') {
              $('#collegeIdOtherDiv').show();
            }
          }

          $("#continueEducationSelect").val(res.data.continueEducation);
          setJobSeekerPath(res.data.resumePath);
          $("#jobType").val(res.data.jobType);

          if (res.data.continueEducation == "Y") {
            $("#continueEduDiv").show();
          } else if (res.data.continueEducation == "N") {
            $("#continueEduDiv").hide();
          }

          $("#collegeId").val(res.data.enrolledCollege);
        }, 2000);
        // $("#profile_image").src(res.resumePath);
      }

    });
  };


  function handleChangeEducation(event) {
    //alert("teste")
    //alert(event.target.value);
    var sch = event.target.value;
    $("#schoolId").val('');
    if (sch == "3") {

      $("#schoolId").prop('disabled', false);
    } else {
      $("#schoolId").prop('disabled', true);
    }
  }


  function handleChangeSchool(event) {
    //alert("teste")
    //alert(event.target.value);
    var sch = event.target.value;
    $('#schoolIdOther').val('');
    //console.log(event.target.value);
    //var sch = $("#schoolId'").val();    
    if (sch == "33") {
      $("#schoolIdOtherDiv").show();
    } else {
      $("#schoolIdOtherDiv").hide();
    }
  }
  function handleChangeContinueEdu(event) {

    var selectedEdu = $('#continueEducationSelect').val();
    //alert(selectedEdu);
    if (selectedEdu == "Y") {
      $("#continueEduDiv").show();
    } else if (selectedEdu == "N") {
      $("#continueEduDiv").hide();
    }

  }
  const getSchoolList = () => {
    //alert("14");
    const requestObject = {
      "siteId": 2,
      "pageNumber": "1",
      "pageSize": 150,
      "orderBy": "name"
    }

    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.getSchoolList(requestOptions).then((res) => {
      console.log("############36");
      console.log(JSON.stringify(res))
      if (res) {
        console.log(JSON.stringify(res.data));


        var contAr = res.content;
        //setProfileList(res.content);
        if (res) {
          setSchoolList(res);
        }


      }
      //navigate('/thankyou');

    });


  }

  function handleChangeCollege(event) {
    //alert("teste")
    //alert(event.target.value);
    var clg = event.target.value;
    $('#collegeIdOther').val('');
    //console.log(event.target.value);
    //var sch = $("#schoolId'").val();    
    if (clg == "22") {
      $("#collegeIdOtherDiv").show();
    } else {
      $("#collegeIdOtherDiv").hide();
    }
  }

  $('#educationId').change(function () {
    $('#school_districtValidMsg').hide();
    $('#university_nameValidMsg').hide();
    if ($('#educationId').val() == 3) {
      $('#school_div').show();
      $('#college_div').hide();
      $('#collegeIdOtherDiv').hide();
      $('#schoolId').prop('disabled', false);
      $('#university_name').val('');
    }
    else {
      $('#school_div').hide();
      $('#college_div').show();
      $('#schoolIdOtherDiv').hide();
      $('#schoolId').prop('disabled', true);
      $('#schoolId').val('');
    }
  })

  const getCollegeInfo = () => {
    services.getEnrolledCollege().then((res) => {
      //console.log("getEducation data=" + JSON.stringify(res.data));
      setCollegeInfo(res.data);
    });
  }


  useEffect(() => {
    //$("#schoolId").prop('disabled', true);
    $('#schoolIdOtherDiv').hide();
    $(".se-dialog-tabs").hide();
    $('#collegeIdOtherDiv').hide();
    // $('#phone_number').usPhoneFormat();
    ($('#phone_number')).usPhoneFormat();
    $("#personalProfileValidMsg").hide();
    $("#educationInfoValidMsg").hide();
    $("#trainingInfoValidMsg").hide();
    $("#seekingPositionValidMsg").hide();
    $("#statusValidMsg").hide();
    $("#firstNameValidMsg").hide();
    $("#lastNameValidMsg").hide();
    $("#phoneValidMsg").hide();
    $("#educationValidMsg").hide();
    $("#schoolValidMsg").hide();
    $("#collegeValidMsg").hide();
    $("#pursuingProgramValidMsg").hide();
    $("#jobtypeValidMsg").hide();
    $("#categoryValidMsg").hide();
    $("#editjobseekersuccessMessage").hide();
    $('#editjobseekerfailMessage').hide();
    $('#continuingEducationValidMsg').hide();
    validateCheck();
    getEducation();
    getProfileData(profileId);
    getSchoolList();
    getCollegeInfo();

    services.getIndustryData().then((res) => {

      console.log("Industry data=" + JSON.stringify(res.data));

      setCategory(res.data.content);

    });
    services.getJobType().then((res) => {
      console.log("setJobType data=" + JSON.stringify(res.data));
      var tempjobtypes = res.data.content;

      var jobtypes_sorted = tempjobtypes.sort((a, b) => b.jobTypeId - a.jobTypeId);
      array_move(jobtypes_sorted, 0, (jobtypes_sorted.length - 1));

      jobtypes_sorted = jobtypes_sorted.filter(function (elem) {
        return elem.name !== 'Job Shadow';
      });
      jobtypes_sorted = jobtypes_sorted.filter(function (elem) {
        return elem.name !== 'Continuing Education';
      });
      setJobType(jobtypes_sorted);
    });
    $("#matchPwd").hide();
    $("#fileError").hide();
    $('#educationValidMsg').hide();
    $('#school_districtValidMsg').hide();
    $('#university_nameValidMsg').hide();
    $('#school_districtValidMsg_m').hide();
    $('#university_nameValidMsg_m').hide();
    $('#schoolIdOtherValidMsg').hide();
    $('#collegeIdOtherValidMsg').hide();
    $("#continuedegreeValidMsg").hide();
    $("#continueprogramValidMsg").hide();
  }, []);
  function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };

  return (
    <>
      <PageTitle breadcrumbs={[]}>Edit Jobseeker</PageTitle>

      <form onSubmit={handleSubmit(submitValue)}>

        {/* <h1>write your code here</h1> */}

        <div className="container">
          <div className="row">

            <div className="col-lg-12">
              <div className="mb-10">

                <div className="d-flex flex-column ">
                  <label className=" required form-label">Status</label>
                  <small className="mb-3">Overall Approval Status</small>
                </div>
                <input type="hidden" id="onloadprofstat" />
                <select id="approval_status" name="approval_status" className="form-select" aria-label="Select example" >
                  <option value="">Select Status</option>
                  <option value="published">Published</option>
                  <option value="pending">Pending</option>
                  {/*<option value="expired">Expired</option>*/}


                </select>
                <div id="statusValidMsg" style={{ color: red }} className="error">Approval Status is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">First Name </label>

                </div>
                <input id="first_name" name="first_name" type="text" className="form-control" defaultValue="title" placeholder="" />
                <div id="firstNameValidMsg" style={{ color: red }} className="error">First Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Last Name </label>

                </div>
                <input type="text" id="last_name" name="last_name" className="form-control" defaultValue="title" placeholder="" />
                <div id="lastNameValidMsg" style={{ color: red }} className="error">Last Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Email</label>
                  <small className="mb-3">Must be valid for notification</small>
                </div>
                <input type="text" id="email_id" name="email_id" className="form-control" defaultValue="title" placeholder="" disabled />

              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Phone</label>
                  <small className="mb-3">xxx-xxx-xxxx</small>
                </div>
                <input type="text" id="phone_number" name="phone_number" className="form-control" defaultValue="title" placeholder="" />
                <div id="phoneValidMsg" style={{ color: red }} className="error">Phone number is required.</div>
              </div>
            </div>


            <div className="col-lg-12 mb-10">
              <div className="mb-2 ">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Personal Profile</label>

                </div>
              </div>
              <div className="row px-3">
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="personalprofile"
                  data={profileInfo.personalProfile}
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setPersonalProfile(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]

                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangePersonalProfileDesc}
                  setContents={profileInfo.personalProfile}
                  //onImageUpload={handleImageUpload}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="personalProfileValidMsg" style={{ color: red }} className="error">Personal Profile is required.</div>
                {/*  <textarea class="form-control textarea" maxlength="500" placeholder="Leave a comment here" id="personalProfile" onChange={e => setFieldName(e.target.value)}  {...register("personalinfo", {
                                    required: "Personal Profile is required.",
                                    maxLength: { value: 500, message: 'Should not allow more than 500 character' }
                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="personalinfo"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                    ? Object.entries(messages).map(([type, message]) => (
                                        <p key={type}  class="error">{message}</p>
                                    ))
                                    : null;
                                }}
                                   
                                /> */}
              </div>
            </div>


            {/* <div className="col-lg-12 mb-10">
                              <div className="mb-2">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">Education / Experience</label>
                                    
                                </div>
                               </div>
                               <div className="row px-3">
                               <CKEditor
                            editor={ ClassicEditor }
                            id="educationInfo"    
                           data={profileInfo.educationExperiance}                          
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setEducationInfo(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        />
                        <div id="educationInfoValidMsg" style={{color:red}} className="error">This field is required.</div>
                       
                              
                               </div>
                        </div> */}
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Level of Education Completed</label>
                </div>
                <select class="form-select" aria-label="Default select example" id="educationId" onChange={handleChangeEducation} >

                  {/* {...register("education_level", {required: "Level of Education is required.",})} */}
                  <option value="">Select</option>
                  {
                    educations.map((data, index) => (
                      <option value={data.educationId}>{data.name}</option>
                    ))}
                </select>
                <div id="educationValidMsg" style={{ color: red }} className="error">Level of Education is required.</div>
              </div>
            </div>
            <div className="col-lg-6" id="school_div">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" required form-label">Graduated From</label>
                </div>
                <select class="form-select" aria-label="Default select example" id="schoolId" name="schoolId" onChange={handleChangeSchool} >
                  {/* {...register("school_list", {required: "School is required.",})} */}
                  <option value="">Select</option>
                  {
                    schoolList.map((data, index) => (
                      <option value={data.schoolId}>{data.name}</option>
                    ))}
                  {/*<option value="0" >Other</option> */}
                </select>
                <div id="schoolValidMsg" style={{ color: red }} className="error">School is required.</div>
              </div>
            </div>

            <div className="col-lg-6" id="schoolIdOtherDiv">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" required form-label">Name of The Institution</label>
                </div>
                <input type="text" class="form-control " id="schoolIdOther" aria-describedby="emailHelp" placeholder="Other" />
                <div id="schoolIdOtherValidMsg" style={{ color: red }} className="error">Name of the Institution is required.</div>
              </div>
            </div>

            <div className="col-lg-6" id="college_div">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" required form-label">College / University</label>
                </div>
                <select class="form-select" id="university_name" onChange={handleChangeCollege}>
                  <option value="">Select College</option>
                  {
                    collegeInfo.map((data, index) => (
                      <option value={data.enrolledCollegeId}>{data.name}</option>
                    ))}
                </select>
                <div id="university_nameValidMsg" style={{ color: red }} className="error">College / Universities is required.</div>
              </div>
            </div>

            <div className="col-lg-6" id="collegeIdOtherDiv">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" required form-label">Name of The Institution</label>
                </div>
                <input type="text" class="form-control " id="collegeIdOther" aria-describedby="emailHelp" placeholder="Other" />
                <div id="collegeIdOtherValidMsg" style={{ color: red }} className="error">Name of the Institution is required.</div>
              </div>
            </div>

            <div className="col-lg-12 mb-10">
              <div >
                <div className="d-flex flex-column ">
                  <label className="required form-label">Are you currently continuing education?</label>
                </div>
              </div>
              <div className="row px-0 mb-10">
                <select class="form-select" id="continueEducationSelect" name="continueEducationSelect" onChange={handleChangeContinueEdu} >
                  <option value="Y">Yes</option>
                  <option value="N">No</option>

                </select>
                <div id="continuingEducationValidMsg" style={{ color: red }} class="error">Are you currently continuing education is required.</div>
                { /*<ul class="col-md-6 mb-4 d-flex">
                                 <li className='d-flex'><input class="form-check form-check-custom form-check-solid" type="radio" name="continueEducation" id="inlineRadio1"  onChange={handleChangeContinueEdu} value="Y" style={{borderRadius: "30px" }}/>
    <label class="form-check-label mx-2" htmlFor="inlineRadio1">YES</label></li> 
    <li className='d-flex mx-3'> <input class="form-check form-check-custom form-check-solid" type="radio" name="continueEducation" id="inlineRadio2" checked onChange={handleChangeContinueEdu} value="N"/>
    <label class="form-check-label mx-2" htmlFor="inlineRadio2">NO</label></li> 
                                 
                                </ul> */}

              </div>
              {errors.category && errors.category.type === "required" && <div style={{ color: red }} className="error">Please check atleast one </div>}
              <div className="row" id="continueEduDiv">

                <div className="col-lg-6">
                  <div>
                    <div className="d-flex flex-column ">
                      <label className="required form-label">Name of the Institution </label>

                    </div>
                    <select class="form-select" id="collegeId" name="collegeId" >
                      <option value=''>Select College</option>
                      {
                        collegeInfo.map((data, index) => (
                          <option value={data.enrolledCollegeId}>{data.name}</option>
                        ))}
                    </select>
                    <div id="collegeValidMsg" style={{ color: red }} className="error">Name of the Institution is required.</div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-0">
                    <div className="d-flex flex-column ">
                      <label className="required form-label">Pursuing Program</label>
                    </div>
                    <input type="text" class="form-control " id="pursuingProgram" name="pursuingProgram" aria-describedby="emailHelp" defaultValue="title" placeholder="pursuing" />
                    <div id="pursuingProgramValidMsg" style={{ color: red }} className="error">Pursuing Program is required.</div>
                  </div>
                </div>
              </div>
            </div>




            <div className="col-lg-12 mb-10">
              <div className="mb-2">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Certification / Training</label>
                </div>
              </div>
              <div className="row px-3">
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="trainingInfo"
                  data={profileInfo.certificationTraining}
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setTrainingInfo(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]

                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeTrainingInfoDesc}
                  setContents={profileInfo.certificationTraining}
                  //onImageUpload={handleImageUpload}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="trainingInfoValidMsg" style={{ color: red }} className="error">Certification is required.</div>


                {/*<textarea class="form-control textarea"   maxlength="500"placeholder="Leave a comment here" id="certificationTraining" onChange={e => setFieldName(e.target.value)} {...register("certificate", {
                                    required: "Certification/training is required.",
                                    maxLength: { value: 500, message: 'Should not allow more than 500 character' }
                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="certificate"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />  */}
              </div>
            </div>
            <div className="col-lg-12 mb-10">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Categories of EXPERTISE</label>
                  {/* <small className="mb-3">Max 3 Categories</small> */}
                </div>
              </div>
              <div className="row px-3">


                {
                  categories.map((data, index) => (

                    <ul class="col-md-6 mb-4">
                      <li className="form-check form-check-custom form-check-solid"><input class="form-check-input" type="checkbox" name="categoryid" value={data.catId} id="defaultCheck1" />  <label class="form-check-label" htmlFor="defaultCheck1"> {data.name} </label></li>
                      {/* {...register('category', { required: true })} */}
                    </ul>
                  ))}


              </div>
              <div id="categoryValidMsg" style={{ color: red }} className="error">Please Check at least 1 category.</div>
              {/* {errors.category && errors.category.type === "required" && <div style={{color:red}} className="error">Please check atleast one category</div>} */}
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Job Type</label>

                </div>
                <select class="form-select" aria-label="Default select example" id="jobType" name="jobType"  >

                  {/* {...register("jobtype", {required: "Job type is required.",})} */}
                  <option selected value="">Select</option>
                  {
                    jobTypes.map((data, index) => (
                      <option value={data.jobTypeId}>{data.name}</option>
                    ))}
                </select>
                <div id="jobtypeValidMsg" style={{ color: red }} className="error">This Field is required.</div>
              </div>
            </div>


            <div className="col-lg-12 mb-10">
              <div className="mb-2">
                <div className="d-flex flex-column ">
                  <label className="required form-label">TELL US WHAT YOU’RE LOOKING FOR</label>
                </div>
              </div>
              <div className="row px-3">
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="lookingFor"
                  data={profileInfo.lookingFor}
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setSeekingPosition(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]

                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeSeekingPositionDesc}
                  setContents={profileInfo.lookingFor}
                  //onImageUpload={handleImageUpload}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="seekingPositionValidMsg" style={{ color: red }} className="error">This field is required.</div>

                {/*
                               <textarea class="form-control textarea" maxlength="500" placeholder="Leave a comment here" id="lookingFor" spellcheck="false" onChange={e => setFieldName(e.target.value)} {...register("looking", {
                                    required: "This field is required.",
                                    maxLength: { value: 500, message: 'Should not allow more than 500 character' }
                                    })}></textarea>
                                 <ErrorMessage
                                    errors={errors}
                                    name="looking"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                /> 
                               */}
              </div>
            </div>



            <div className="col-lg-12 mb-10">
              <div className="mb-2">
                <div className="d-flex flex-column ">
                  <label className="form-label">UPLOAD A RESUME</label>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">

                  <input class="form-control form-control-lg browse mr-2" id="resume" name="resume" type="file" onChange={() => getImage()} />
                </div>
              </div>
              <small> 1MB Max, File Type: PDF,DOC</small>
            </div>
            <div id="fileError" style={{ color: red }} className="error">Invalid file format</div>


            {jobSeekerResumePath != '' ? <div className="mb-10">
              <a href={jobSeekerResumePath} download="resume" target="_blank"><button type="button">Download Current Resume</button></a>
            </div> : ''}

            <div className="col-lg-12 mb-10">
              
              <div className="row">
                <div className="col-md-6">

                <input class="form-check-input" type="checkbox" name="deactivate_profile" value="Y" id="deactivate_profile" />  <label class="form-label" htmlFor="deactivate_profile"> Deactivate </label>
                </div>
              </div>
            </div>

            <button type="submit" className="btn btn-primary mt-5" style={{ maxWidth: "200px" }}> Update </button>
          </div>
          <div id="editjobseekersuccessMessage" class="alert alert-success" role="alert">Jobseeker Updated Successfully</div>
          <div id="editjobseekerfailMessage" class="alert alert-danger" role="alert">Please try again</div>
        </div>

      </form>


    </>
  )
}
export { EditJobseeker }